(function () {
  const designersRoots = document.querySelectorAll(
    '.section-collections-links.is-designers-directory'
  );

  function getToggleBreakpoint(element) {
    const breakpointContainer = element.closest('[data-toggle-breakpoint]');
    const breakpoint = Number.parseInt(
      breakpointContainer ? breakpointContainer.dataset.toggleBreakpoint : '',
      10
    );

    return Number.isFinite(breakpoint) ? breakpoint : null;
  }

  function isWithinToggleBreakpoint(element) {
    const breakpoint = getToggleBreakpoint(element);

    if (!breakpoint) return false;

    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  }

  function elementNeedsToggle(element) {
    if (!element || !element.offsetWidth) return false;

    const clone = element.cloneNode(true);

    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.left = '-9999px';
    clone.style.top = '0';
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.overflow = 'visible';
    clone.style.display = 'block';
    clone.style.width = element.getBoundingClientRect().width + 'px';
    clone.style.webkitLineClamp = 'unset';
    clone.style.lineClamp = 'unset';
    clone.style.webkitBoxOrient = 'initial';

    document.body.appendChild(clone);

    const fullHeight = clone.getBoundingClientRect().height;

    clone.remove();

    return fullHeight > element.getBoundingClientRect().height + 1;
  }

  function updateDesignerToggle(item) {
    const title = item.querySelector('[data-designer-title]');
    const toggle = item.querySelector('[data-designer-toggle]');

    if (!title || !toggle) return;

    const isMobile = isWithinToggleBreakpoint(item);
    const wasExpanded = item.classList.contains('is-expanded');

    if (!isMobile) {
      item.classList.remove('is-toggle-active');
      item.classList.remove('is-expanded');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = toggle.dataset.labelMore || '';
      return;
    }

    if (wasExpanded) item.classList.remove('is-expanded');

    const needsToggle = elementNeedsToggle(title);

    item.classList.toggle('is-toggle-active', needsToggle);

    if (needsToggle && wasExpanded) item.classList.add('is-expanded');
    if (!needsToggle) item.classList.remove('is-expanded');

    toggle.hidden = !needsToggle;
    toggle.setAttribute(
      'aria-expanded',
      needsToggle && item.classList.contains('is-expanded') ? 'true' : 'false'
    );
    toggle.textContent =
      needsToggle && item.classList.contains('is-expanded')
        ? (toggle.dataset.labelLess || '')
        : (toggle.dataset.labelMore || '');
  }

  function updateAllDesignerToggles() {
    designersRoots.forEach(function (designersRoot) {
      designersRoot
        .querySelectorAll('[data-designer-card]')
        .forEach(function (item) {
          updateDesignerToggle(item);
        });
    });
  }

  function updateCollectionDescriptionToggle(card) {
    const description = card.querySelector('[data-collection-description]');
    const toggle = card.querySelector('[data-collection-description-toggle]');

    if (!description || !toggle) return;

    const isMobile = isWithinToggleBreakpoint(card);
    const wasExpanded = card.classList.contains('is-expanded');

    if (!isMobile) {
      card.classList.remove('is-toggle-active');
      card.classList.remove('is-expanded');
      card.classList.remove('is-collapsing');
      description.style.maxHeight = '';
      description.style.overflow = '';
      description.style.transition = '';
      description.style.opacity = '';
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = toggle.dataset.labelMore || '';
      return;
    }

    const collapsedHeight = getCollectionDescriptionCollapsedHeight(description);
    const needsToggle = description.scrollHeight > collapsedHeight + 1;

    card.classList.toggle('is-toggle-active', needsToggle);

    if (needsToggle && wasExpanded) {
      card.classList.add('is-expanded');
      description.style.maxHeight = 'none';
      description.style.overflow = 'visible';
    } else {
      card.classList.remove('is-expanded');
      card.classList.remove('is-collapsing');
      description.style.maxHeight = '';
      description.style.overflow = '';
    }

    if (!needsToggle) {
      card.classList.remove('is-expanded');
      card.classList.remove('is-collapsing');
      description.style.maxHeight = '';
      description.style.overflow = '';
      description.style.transition = '';
      description.style.opacity = '';
    }

    toggle.hidden = !needsToggle;
    toggle.setAttribute(
      'aria-expanded',
      needsToggle && card.classList.contains('is-expanded') ? 'true' : 'false'
    );
    toggle.textContent =
      needsToggle && card.classList.contains('is-expanded')
        ? (toggle.dataset.labelLess || '')
        : (toggle.dataset.labelMore || '');
  }

  function getCollectionDescriptionCollapsedHeight(description) {
    const styles = window.getComputedStyle(description);
    const cssLines = description.style
      .getPropertyValue('--collection-rich-text-mobile-lines')
      .trim();
    const lines = Number.parseInt(cssLines || '4', 10) || 4;
    const lineHeight = Number.parseFloat(styles.lineHeight);
    const fontSize = Number.parseFloat(styles.fontSize) || 16;
    const resolvedLineHeight = Number.isFinite(lineHeight)
      ? lineHeight
      : fontSize * 1.8;

    return resolvedLineHeight * lines;
  }

  function animateCollectionDescription(card, expand) {
    const description = card.querySelector('[data-collection-description]');

    if (!description) return;

    const collapsedHeight = getCollectionDescriptionCollapsedHeight(description);
    const expandedHeight = description.scrollHeight;
    const fromHeight = expand ? collapsedHeight : expandedHeight;
    const toHeight = expand ? expandedHeight : collapsedHeight;

    description.style.overflow = 'hidden';
    description.style.transition = 'max-height 260ms ease, opacity 220ms ease';
    description.style.maxHeight = fromHeight + 'px';
    description.style.opacity = '0.92';

    description.getBoundingClientRect();

    window.requestAnimationFrame(function () {
      description.style.maxHeight = toHeight + 'px';
      description.style.opacity = '1';
    });

    const handleTransitionEnd = function (event) {
      if (event.propertyName !== 'max-height') return;

      if (expand) {
        description.style.maxHeight = 'none';
        description.style.overflow = 'visible';
      } else {
        card.classList.remove('is-collapsing');
        description.style.maxHeight = collapsedHeight + 'px';
        description.style.overflow = 'hidden';
      }

      description.style.opacity = '';
      description.style.transition = '';
      description.removeEventListener('transitionend', handleTransitionEnd);
    };

    description.addEventListener('transitionend', handleTransitionEnd);
  }

  function updateAllCollectionDescriptionToggles() {
    document
      .querySelectorAll('[data-collection-description-card]')
      .forEach(function (card) {
        updateCollectionDescriptionToggle(card);
      });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest(
      '[data-designer-toggle], [data-collection-description-toggle]'
    );

    if (!toggle) return;

    const item =
      toggle.closest('.section-collections-links-collection') ||
      toggle.closest('[data-collection-description-card]');

    if (!item) return;

    if (toggle.matches('[data-collection-description-toggle]')) {
      const isExpanded = item.classList.contains('is-expanded');

      if (isExpanded) {
        item.classList.add('is-collapsing');
        item.classList.remove('is-expanded');
        animateCollectionDescription(item, false);
      } else {
        item.classList.remove('is-collapsing');
        item.classList.add('is-expanded');
        animateCollectionDescription(item, true);
      }

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      toggle.textContent = isExpanded
        ? (toggle.dataset.labelMore || '')
        : (toggle.dataset.labelLess || '');
      return;
    }

    const isExpanded = item.classList.toggle('is-expanded');

    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    toggle.textContent = isExpanded
      ? (toggle.dataset.labelLess || '')
      : (toggle.dataset.labelMore || '');
  });

  updateAllDesignerToggles();
  updateAllCollectionDescriptionToggles();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      updateAllDesignerToggles();
      updateAllCollectionDescriptionToggles();
    });
  }

  let resizeFrame = null;

  window.addEventListener('resize', function () {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);

    resizeFrame = window.requestAnimationFrame(function () {
      updateAllDesignerToggles();
      updateAllCollectionDescriptionToggles();
      resizeFrame = null;
    });
  });
})();
